<template>
  <div>
    <a-upload
      name="file"
      list-type="picture-card"
      class="avatar-uploader"
      :show-upload-list="false"
      :customRequest="handleHttpRequest"
      :before-upload="beforeAvatarUpload">
      <img
        ref="img"
        v-if="currentImgPath && type==='IMAGE'"
        :src="currentImgPath"
        alt="avatar"
        style="width: 100%"/>
      <video
        ref="video"
        v-if="currentImgPath && type==='VIDEO'"
        :src="currentImgPath"
        style="width: 100%"/>
      <div
        v-if="!currentImgPath">
        <a-icon :type="loading ? 'loading' : 'plus'"/>
        <div class="ant-upload-text">Upload</div>
      </div>
      <div
        v-else
        @click="removeFile"
        class="remove-btn-wrap">
        <a-button type="danger" size="small" shape="round">clear</a-button>
      </div>
    </a-upload>
    <!--    <span @click="()=>{review= true}">预览</span>-->
    <a-modal
      :footer="null"
      title="联名编辑"
      v-model="review">
      <img
        v-if="type==='IMAGE'"
        :src="currentImgPath"
        alt=""/>
      <video
        v-if="type==='VIDEO'"
        :src="currentImgPath"
        style="width: 100%;height: auto"/>
      <audio
        v-if="type==='AUDIO'"
        :src="currentImgPath"
        style="width: 100%;height: auto"/>
    </a-modal>
  </div>
</template>

<script>
import OssClient from '@/utils/OssClient';

export default {
  name: 'SimpleUploader',
  props: {
    value: String,
    type: {
      type: String,
      default: 'IMAGE',
    },
  },
  watch: {
    value(val) {
      this.currentImgPath = val;
    },
  },
  data() {
    return {
      loading: false,
      review: false,
      imageUrl: '',
      currentImgPath: this.value,
      // headers: {
      //   token: localStorage.getItem('token'),
      // },
      // uploadUrl: `${process.env.VUE_APP_BASE_URL}/upload`,
    };
  },
  methods: {
    getSize() {
      if (this.type === 'IMAGE') {
        return {
          width: this.$refs.img.naturalWidth,
          height: this.$refs.img.naturalHeight,
        };
      }
      return {
        width: this.$refs.video.videoWidth,
        height: this.$refs.video.videoHeight,
      };
    },

    random_string(len) {
      // len = len || 32;
      const length = len || 32;
      const chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz12345678';
      const maxPos = chars.length;
      let pwd = '';
      for (let i = 0; i < length; i++) {
        pwd += chars.charAt(Math.floor(Math.random() * maxPos));
      }
      return pwd;
    },
    async handleHttpRequest(option) {
      // 上传OSS
      const client = OssClient();
      // 随机命名
      const randomName = `${this.random_string(6)}_${new Date().getTime()}.${option.file.name
        .split('.')
        .pop()}`;

      try {
        // 分片上传文件
        const result = await client.put(randomName, option.file);
        if (result) {
          const pre = result.url.split('//');
          const suffix = pre[1].split('.');
          if (this.type === 'IMAGE') {
            this.currentImgPath = 'https://' + pre[1] + '?x-oss-process=image/format,webp';
          } else {
            this.currentImgPath = 'https://' + pre[1];
          }
          this.$emit('input', this.currentImgPath);
        }
      } catch (error) {
        this.$message.error('上传失败');
      }
    },

    removeFile(e) {
      e.preventDefault();
      e.stopPropagation();
      this.currentImgPath = null;
      this.$emit('input', null);
    },
    // handleChange(info) {
    //   if (info.file.status === 'uploading') {
    //     this.loading = true;
    //     return;
    //   }
    //   if (info.file.status === 'done') {
    //     this.loading = false;
    //     this.currentImgPath = info.file.response;
    //     this.$emit('input', info.file.response);
    //   }
    // },
    beforeUpload(file) {
      const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
      if (!isJpgOrPng) {
        this.$message.error('You can only upload JPG file!');
      }
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isLt2M) {
        this.$message.error('Image must smaller than 2MB!');
      }
      return isJpgOrPng && isLt2M;
    },
    handleAvatarSuccess(res) {
      this.currentImgPath = res;
      this.$emit('input', res);
    },
    beforeAvatarUpload(file) {
      return true;
    },
  },
};
</script>

<!--<style>-->
<!--.remove-btn-wrap {-->
<!--  position: absolute;-->
<!--  left: 0;-->
<!--  bottom: 0;-->
<!--  right: 0;-->
<!--  top: 0;-->
<!--  text-align: center;-->
<!--  display: none;-->
<!--  align-items: center;-->
<!--  justify-content: center;-->
<!--  background: rgba(0, 0, 0, 0.5);-->
<!--}-->

<!--.ant-upload:hover .remove-btn-wrap {-->
<!--  display: flex;-->
<!--}-->

<!--</style>-->

<style>
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 0;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.el-upload--picture-card {
  border-radius: 0;
}

.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 148px;
  height: 148px;
  line-height: 148px;
  text-align: center;
}

.avatar {
  width: 148px;
  height: auto;
  display: block;
}

.el-upload-list__item {
  border-radius: 0;
}

.avatar-uploader > .ant-upload {
  width: 128px;
  height: 128px;
}

.ant-upload-select-picture-card i {
  font-size: 32px;
  color: #999;
}

.ant-upload-select-picture-card .ant-upload-text {
  margin-top: 8px;
  color: #666;
}
</style>
